const BRAND_CATALOG = [
  {
    category: 'shoes',
    label: "Shoes",
    items: [
      "550 Chelsea Boots Brown.jpeg",
      "Adidas Campus 00s.webp",
      "Adidas Gazelle.webp",
      "Adidas Samba Gold.webp",
      "Adidas Samba OG Shoes White.webp",
      "Adidas Samba Silver.webp",
      "Adidas Samba White.webp",
      "Asics Gel-Kayano 14.webp",
      "Asics Shoes Gel Nimbus Grey White.jpeg",
      "Asics Sneakers Onitsuka Tiger Mexico 66.jpeg",
      "Asics White Leather Shoes.webp",
      "Asics White Shoes.webp",
      "Birkenstock Boston Black .png",
      "Birkenstock Boston Soft Footbed.png",
      "Blundstone Chelsea Boots.webp",
      "Brooks Men Shoes Ghost 17 black.jpeg",
      "Brooks Shoes Ghost 17 Beige.jpeg",
      "Classic Clog Black.png",
      "Converse Chuck 70.webp",
      "converse shows pen drawn.jpg",
      "Converse Sneakers Rainbow.jpg",
      "Crocs with Jibbitz.webp",
      "Hoka Bondi 8.webp",
      "Hoka Clifton 9.webp",
      "Hoka Shoes Clifton 10 Black.jpeg",
      "Hoka Shoes Clifton 10 Pink.jpeg",
      "Merrell Hydro Moc.webp",
      "New Balance 2002R White.jpeg",
      "New Balance 550 Green.jpeg",
      "New Balance 550.webp",
      "New Balance 740 White and Silver.png",
      "Nike Air Force 1 '07.avif",
      "Nike Dunk Low Panda.webp",
      "Nike Pegasus 41 White.jpeg",
      "Nike Pegasus 41.webp",
      "Nike Pegasus 42 Purple.jpeg",
      "Nike Pegasus 42 White.jpeg",
      "Nike Vomero 5.webp",
      "On Cloud 5 Shoe.webp",
      "On Cloudmonster Black.jpeg",
      "On Cloudnova Shoes.webp",
      "Reebok Club C 85.webp",
      "Salomon XT-6.webp",
      "Salomon XT‑6 Trail Runners.jpeg",
      "Ugg Tasman - Chestnut.png",
      "Women's Classic Ultra Mini Chestnut.webp"
    ],
  },
  {
    category: 'bags',
    label: "Bags & Accessories",
    items: [
      "Baggu Puffy Tote.webp",
      "Cotopaxi Luzon Daypack.webp",
      "Dual Pouch Wristlet Pink+white.webp",
      "Everlane Cactus Leather Tote.webp",
      "Kitsch claw clip.jpeg",
      "Long Champ Le Pilage Size Large Black.png",
      "Longchamp Le Pliage Original L Tote bag Navy.png",
      "Lululemon Dual Pouch Wristlet BlackGold.png",
      "Lululemon Everywhere Belt Bag.webp",
      "luvtote.png",
      "Patagonia Black Hole Tote.webp",
      "Prada claw clip.jpeg",
      "The North Face Borealis-Backpack - Black.avif",
      "Tote Bag Keychain.webp",
      "Trader Joes Mini Tote Bag Navy.webp",
      "Uniqlo Round Mini Shoulder Bag.webp"
    ],
  },
  {
    category: 'tops',
    label: "Tees & Tops",
    items: [
      "NAADAM The Classic Tee Granite Women.jpeg",
      "Skims Cotton Jersey Tee Black W.jpeg",
      "Tentree Plant More Trees Cotton Tee.webp",
      "The Smiths tee.jpeg",
      "Uniqlo Airism Tee Black.jpeg",
      "Uniqlo Airism Tee White.jpeg",
      "Uniqlo U Crew Neck Tee Black.webp",
      "Uniqlo U Crew Neck Tee White.webp",
      "Urban Outfitters Queen Tee W.jpg"
    ],
  },
  {
    category: 'hoodies',
    label: "Hoodies & Sweaters",
    items: [
      "Ader Error Hoodie Black.jpeg",
      "Ader Error Oversized Hoodie Green.png",
      "Ader Error Oversized Hoodie Grey.webp",
      "Alo Black Hoodie.jpg",
      "Aritzia Boyfriend Hoodie White W.jpeg",
      "Aritzia Hoodie Black W.jpeg",
      "Aritzia The Super Puff Shorty - Black.avif",
      "Basic Studdy Zip Hoodie - Ash Heather.png",
      "Carhartt Hooded Sweatshirt Blue.jpg",
      "Carhartt Hooded Sweatshirt Grey.jpg",
      "Champion Hoodie tie dye red.jpg",
      "Essentials Classic Fleece Zip-Up Hoodie Jet Black.png",
      "Essentials Pullover Hoodie Black.jpg",
      "Fear of God Essentials Pullover Hoodie Black .png",
      "GitHub Octocat Hoodie.jpg",
      "GitHub Octocat Zip Hoodie.webp",
      "Lululemon City Sweat Zip Hoodie Blue.jpeg",
      "Lululemon Hoodie Grey.jpeg",
      "Lululemon Scuba Oversized Half Zip Black W.jpeg",
      "Patagonia Better Sweater Beige Women.jpeg",
      "Patagonia Better Sweater Fleece Forest Green.webp",
      "Patagonia Better Sweater Grey Men.jpeg",
      "Patagonia Better Sweater Grey Women.jpeg",
      "Patagonia Better Sweater.webp",
      "Quince Pullover Hoodie Grey.jpeg",
      "Stussy Zip Hoodie Black.png",
      "Under Armour hoodie black.jpeg",
      "Under Armour hoodie blue.jpeg",
      "Uniqlo Pullover Hoodie Black.jpeg",
      "Uniqlo Pullover Hoodie White.jpeg",
      "Uniqlo Zip Hoodie Black.jpeg",
      "Vuori Zip Hoodie Grey.jpeg"
    ],
  },
  {
    category: 'bottoms',
    label: "Pants & Bottoms",
    items: [
      "Aritzia Effortless Pant Black W.jpeg",
      "Bonobos Linen Dress Pants Green.jpeg",
      "Bonobos Semicasual Pants Brown.jpeg.jpeg",
      "Bonobos Weekday Dress Pants Blue.jpeg",
      "Bonobos Weekday Dress Pants Brown.jpeg",
      "CarharttWIP-RegularCargoMoragaPant.webp",
      "CarharttWIP-RegularCargoPantBrown.webp",
      "Dickies 874 Work Pants Black W.jpeg",
      "Dickies Painter Pants.jpeg",
      "Everlan Jogger Pant Green Men.webp",
      "Everlane Linen Pants Black.jpeg",
      "Everlane Linen Pants Grey.webp",
      "Everlane Trouser Men White.webp",
      "Levis Ribcage Straight Ankle Jeans W.jpeg",
      "Men Linen Pants.jpeg",
      "Pleats Please Issey Miyake Trousers Green W.jpeg",
      "Pleats Please Issey Miyake Trousers Navy W.jpeg"
    ],
  },
  {
    category: 'beanies',
    label: "Beanies & Hats",
    items: [
      "Aime Leon Dore Dad Hat.jpeg",
      "Aime Leon Dore NY Dad Hat beige.jpeg",
      "Aime Leon Dore NY Dad Hat green.webp",
      "Alo Beanie Brown.webp",
      "Alo Beanie Green.webp",
      "Alo Beanie Pink.webp",
      "Alo Beanie Red.webp",
      "Alo Beanie White.webp",
      "Alo Hat Black.webp",
      "Alo Hat Pink.webp",
      "Alo Hat White.webp",
      "Bucket Hat Paint Splatter BW.jpg",
      "Bucket Hat Paint Splatter Color.jpeg",
      "Carhartt Beanie.webp",
      "Crochet Handmade Beanie.webp",
      "Gentle Monster Maison Margiela Cap.jpeg",
      "Kangol Wool Beret Black.jpeg",
      "Kangol Wool Beret Blue.jpeg",
      "Lululemon Fast and Free Hat.webp",
      "Nike Dri-Fit Cap.webp",
      "North Face Beanie.webp",
      "Patagonia Trucker Hat White.jpeg",
      "Patagonia Trucker Hat.webp",
      "Stussy Bucket Hat Purple.webp"
    ],
  },
  {
    category: 'drinkware',
    label: "Drinkware",
    items: [
      "CamelBak Chute Bottle.webp",
      "HydroFlask 32oz Tonal Trillium.png",
      "Klean Kanteen Bottle.webp",
      "Miir Bottle.webp",
      "Nalgene 32oz Bottle.webp",
      "Owala Free Sip Quartz.webp",
      "Owala Freesip Shy Marshmallow.png",
      "Starbucks Reusable Cold Cup.webp",
      "The Quencher H2.0 Flowstate Tumbler - Cream 2.0.png"
    ],
  },
  {
    category: 'electronics',
    label: "Electronics",
    items: [
      "Apple Airpods Max Midnight.png",
      "Apple EarPods (USB-C).jpeg",
      "HP ProBook 4 Silver.webp",
      "iPad Air with Apple Pencil.webp",
      "Kindle Paperwhite.webp",
      "Macbook Air - Silver.jpg",
      "MacBook Air 13inch Midnight.png",
      "Sony - WH-1000XM5 Wireless Noise-Canceling Over-the-Ear Headphones - Silver.png"
    ],
  },
  {
    category: 'academic',
    label: "Academic Essentials",
    items: [
      "Moleskine Notebook.webp",
      "Muji Gel Pens.webp",
      "Pilot MR Metropolitan Fountain Pen.webp"
    ],
  },
  {
    category: 'lifestyle',
    label: "Lifestyle & Everyday",
    items: [
      "Hand Sanitizer.webp",
      "Mini Umbrella.webp",
      "Portable Hammock.webp",
      "Portable Picnic Chair.webp",
      "Yoga Mat.webp"
    ],
  },
  {
    category: 'food',
    label: "Food & Snacks",
    items: [
      "Clif Bar.webp",
      "Fresh Fruit Cup.webp",
      "Instant Ramen.webp",
      "LaCroix Sparkling Water.webp",
      "Protein Shake.webp",
      "Seaweed Snack Pack.webp",
      "Yerba Mate.webp"
    ],
  },
  {
    category: 'wellness',
    label: "Wellness & Athleisure",
    items: [
      "Figs blue women.png",
      "Figs pink women.png",
      "Lululemon Align Leggings.webp",
      "Lululemon Groove High Rise Pants Black W.jpeg",
      "Lululemon Groove High Rise Pants Red W.webp",
      "Lululemon Softstreme Sweatpants men brown.jpeg",
      "Lululemon Softstreme Sweatpants men white.jpeg",
      "Lululemon Softstreme Sweatpants women black.jpeg",
      "Lululemon Softstreme Sweatpants women white.jpeg",
      "Lululemon Train Shorts Black W.jpeg",
      "Nike Dri Fit Shorts Man Black.webp",
      "Nike Dri Fit Tee Men Black.jpg",
      "Nike Pro 365 Shorts Women Black.webp",
      "Shaker Bottle.webp"
    ],
  },
  {
    category: 'berkeley',
    label: "UC Berkeley-Specific",
    items: [
      "Cal Golden Bear Hat.jpeg",
      "Cal Golden Bears Beanie.jpg",
      "Cal Pennant.webp",
      "Cal-Branded Tote Bag.webp",
      "Champion Cal Hoodie.jpeg",
      "Nike Cal Athletics Tee.jpeg",
      "UC Berkeley Dad Hat.webp",
      "University Of California Berkeley Champion Arch & Seal Men's hoodie Sweatshirt - Grey.webp",
      "University of California Berkeley hoodie Navy.png"
    ],
  },
  {
    category: 'sf-sports',
    label: "Bay Area Sports",
    items: [
      "baseball hat mens new era black san-francisco giants.avif",
      "baseball hat mens new era orange san-francisco giants.avif",
      "mens new-era black san-francisco giants baseball hat.avif",
      "mens nike jung-hoo-lee cream san-francisco giants baseball game-jersey.avif",
      "mens giants hoodie black.avif",
      "black golden state-warriors bucket hat.avif",
      "blue golden state-warriors bucket hat.avif",
      "golden state warriors 80s-throwback basketball hat.avif",
      "tan golden state-warriors basketball hat.avif",
      "mens blue golden state-warriors basketball game-jersey.avif",
      "mens stephen-curry black golden state-warriors basketball game-jersey.avif",
      "mens white golden state-warriors basketball game-jersey.avif",
      "mens 49ers hoodie black and red.jpeg",
      "mens nike george-kittle-scarlet 49ers basketball game-jersey.jpg",
      "san-francisco 49ers basketball game-jersey red.avif",
    ],
  },
  {
    category: 'other',
    label: "Other",
    items: [
      "anastasia.jpg",
      "AOVOPRO ES80 Electric Scooter.png",
      "becks.jpg",
      "Bike Helmet with Stickers.webp",
      "Fixie Bike.webp",
      "foxshirt.webp",
      "lululemon-abc-jogger-warpstreme-iron-blue-026865-419521.jpg",
      "REI Daypack.webp",
      "Tie Dye Shirt.webp"
    ],
  },
];

function brandUrl(filename) {
  return `${process.env.PUBLIC_URL || ''}/brands/${encodeURIComponent(filename).replace(/'/g, '%27')}`;
}

/**
 * Homepage hero sample poster only: recognizable products (athletic,
 * outdoors, SF sports, drinkware, tech). Full `getVariedBrandSample`
 * stays for survey grids.
 */
const HERO_SAMPLE_BRAND_FILES = [
  'Adidas Samba OG Shoes White.webp',
  'Birkenstock Boston Soft Footbed.png',
  'Patagonia Black Hole Tote.webp',
  'Trader Joes Mini Tote Bag Navy.webp',
  'HydroFlask 32oz Tonal Trillium.png',
  'Nike Cal Athletics Tee.jpeg',
  'baseball hat mens new era orange san-francisco giants.avif',
  'mens giants hoodie black.avif',
  'mens nike jung-hoo-lee cream san-francisco giants baseball game-jersey.avif',
  'black golden state-warriors bucket hat.avif',
  'blue golden state-warriors bucket hat.avif',
  'mens stephen-curry black golden state-warriors basketball game-jersey.avif',
  'mens 49ers hoodie black and red.jpeg',
  'san-francisco 49ers basketball game-jersey red.avif',
];

const heroSampleBrandPool = HERO_SAMPLE_BRAND_FILES.map((file) => {
  const imageUrl = brandUrl(file);
  const name = file.replace(/\.(png|jpg|jpeg|webp|avif)$/i, '');
  return { imageUrl, name, id: imageUrl, category: 'hero_sample' };
});

/** Random subset of the curated hero pool (same shape as `getVariedBrandSample` items). */
export function getRandomHeroSampleSwags(count = 3) {
  const shuffled = [...heroSampleBrandPool].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, Math.min(count, shuffled.length));
}

export const brandCatalog = BRAND_CATALOG.map(({ category, label, items }) => ({
  category,
  label,
  items: items.map((file) => {
    const imageUrl = brandUrl(file);
    const name = file.replace(/\.(png|jpg|jpeg|webp|avif)$/i, '');
    return { imageUrl, name, id: imageUrl, category };
  }),
}));

export const allBrands = brandCatalog.flatMap((cat) => cat.items);

export const brandSamples = allBrands.map((b) => b.imageUrl);

export function getRandomBrandSamples(count = 3) {
  const shuffled = [...allBrands].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}

/**
 * Picks one random item from each of N randomly-chosen categories,
 * guaranteeing visual variety in the survey grid.
 */
/* First FoxChat brand grid: the homepage pre-picks these 9 tiles once everything else has
   loaded and warms their images in the browser cache, so the chat opens with the grid ready.
   The sample is consumed once (first chat open); later sessions fall back to a fresh pick. */
let pendingInitialBrandSample = null;
let initialBrandSampleConsumed = false;

export function warmInitialBrandSample(count = 9) {
  if (initialBrandSampleConsumed || pendingInitialBrandSample) return;
  if (typeof window === 'undefined' || typeof window.Image === 'undefined') return;
  pendingInitialBrandSample = getVariedBrandSample(count);
  pendingInitialBrandSample.forEach(({ imageUrl }) => {
    const img = new window.Image();
    img.src = imageUrl;
  });
}

export function takeInitialBrandSample(count = 9) {
  initialBrandSampleConsumed = true;
  const sample = pendingInitialBrandSample;
  pendingInitialBrandSample = null;
  if (sample && sample.length >= count) return sample.slice(0, count);
  return getVariedBrandSample(count);
}

export function getVariedBrandSample(count = 9) {
  const shuffledCats = [...brandCatalog].sort(() => Math.random() - 0.5);
  const picks = [];
  for (const cat of shuffledCats) {
    if (picks.length >= count) break;
    const item = cat.items[Math.floor(Math.random() * cat.items.length)];
    picks.push(item);
  }
  while (picks.length < count) {
    const remaining = allBrands.filter((b) => !picks.some((p) => p.id === b.id));
    if (remaining.length === 0) break;
    picks.push(remaining[Math.floor(Math.random() * remaining.length)]);
  }
  return picks;
}

export const BRAND_FILES = BRAND_CATALOG.flatMap((cat) => cat.items);
